import { IconsProps } from '../IconsProps';

const Debica = ({
  className = '',
  viewBox = '0 0 116 27',
  width = 116,
  height = 27,
  onClick,
  svgFill = 'currentColor',
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label="Debica"
    >
      <g clipPath="url(#clip0_8354_130008)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66736 7.44765L0.828125 5.35274L28.3092 5.30957C34.5779 5.30957 36.9452 7.74404 35.9375 11.8936C35.017 15.8359 30.7216 18.7711 26.0742 18.7711H10.8267L9.95138 16.6733H17.5767L18.0158 14.9957H7.74652L6.87119 12.8576H18.6174L19.0566 11.2231H4.69039L3.85718 9.12531H25.9509L23.713 16.7165H24.459C26.8262 16.7165 28.6702 14.9554 29.4552 12.0202C30.2403 9.08502 29.1544 7.44765 27.0007 7.44765H1.66736Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.1067 5.32129C56.236 5.50546 56.1909 5.62631 56.0856 5.99177L52.7076 18.0778C52.6605 18.3301 52.5347 18.5629 52.3467 18.7454H61.9061C65.0314 18.7454 67.4107 17.2836 68.0454 15.0045C68.5778 13.1139 67.7717 12.1585 65.6029 11.7326C66.1915 11.6506 66.7642 11.4858 67.3024 11.2434C67.8343 11.0168 68.3057 10.6781 68.6812 10.2525C69.0568 9.82691 69.3269 9.32555 69.4712 8.78596C70.0878 6.55004 68.7072 5.3328 65.5819 5.3328L56.1067 5.32129ZM60.8232 11.114L61.9061 7.25217H62.3964C63.4793 7.25217 63.8192 7.8018 63.4582 9.0622C63.0341 10.5873 62.4806 11.114 61.3135 11.114H60.8232ZM59.2079 16.8692L60.2938 13.0074H61.0368C62.0324 13.0074 62.2671 13.5973 61.864 15.0592C61.503 16.3196 60.9616 16.8692 59.8667 16.8692H59.2079Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.801 5.32129C74.8609 5.42228 74.8975 5.53435 74.9084 5.64999C74.9193 5.76563 74.9042 5.88216 74.8642 5.99177L71.4862 18.0778C71.4083 18.3368 71.2537 18.5687 71.041 18.7454H77.6285C77.5486 18.5281 77.5561 18.2901 77.6496 18.0778L81.0276 5.99177C81.0678 5.73707 81.1934 5.50177 81.3855 5.32129H74.801Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.423 5.73261C98.8404 5.24028 97.1806 5.01344 95.5171 5.06212C92.0549 5.06212 89.6725 5.61175 87.4436 6.83186C85.2989 8.03184 84.1348 9.53396 83.4701 11.8936C82.1315 16.6705 84.6161 19.0273 91.0322 19.0273C93.0257 19.0691 95.0133 18.8039 96.9188 18.2417L97.7069 15.4561C95.5171 16.4921 94.2627 16.9179 92.861 16.9179C91.712 16.9179 90.7554 16.4921 90.205 15.7669C89.462 14.9324 89.3988 13.7123 89.8861 11.9656C90.7163 8.95843 92.8941 7.12826 95.5171 7.12826C96.9188 7.12826 98.0227 7.55415 99.617 8.65053L100.423 5.74412V5.73261Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M104.375 15.3351H109.474L109.943 18.0602C109.973 18.2216 109.988 18.3855 109.985 18.5494C109.975 18.588 109.956 18.624 109.93 18.6552C109.904 18.6864 109.872 18.7121 109.835 18.7307H116.846C116.747 18.6468 116.667 18.5436 116.612 18.4281C116.557 18.3125 116.528 18.1872 116.528 18.0602L113.98 5.9742C113.936 5.79434 113.936 5.60731 113.98 5.42745L114.001 5.30371H108.815C108.851 5.33627 108.874 5.38025 108.878 5.42745C108.787 5.61739 108.68 5.8002 108.559 5.9742L99.3188 18.0602C99.1365 18.3378 98.8854 18.5681 98.5879 18.7307H102.017C101.954 18.6703 101.975 18.6099 101.996 18.5494C102.017 18.489 102.143 18.3048 102.297 18.0602L104.378 15.3351H104.375ZM105.84 13.2834L108.668 9.4216L109.134 13.2834H105.84Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.3846 20.4487H42.7085L42.2393 22.1264H47.9364L48.3846 20.4487Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.8352 5.32129C40.9435 5.50546 40.8984 5.68674 40.8141 5.99177L37.4362 18.0778C37.3917 18.331 37.2655 18.5644 37.0752 18.7454H48.7823L49.3538 16.6332C48.9976 16.7014 48.6332 16.7227 48.271 16.6966H43.9996L45.0404 12.9556H49.4832C49.7855 12.9375 50.0889 12.9578 50.3856 13.0161L50.9571 10.9614C50.6287 11.0647 50.2811 11.1 49.9374 11.065H45.5818L46.6647 7.20326H51.1075C51.4097 7.19235 51.7122 7.21261 52.0099 7.26369L52.5423 5.3328L40.8352 5.32129Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8354_130008">
          <rect width="116" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Debica;
